import { render, staticRenderFns } from "./5GTablet.vue?vue&type=template&id=4b991e77&scoped=true"
import script from "./5GTablet.vue?vue&type=script&lang=js"
export * from "./5GTablet.vue?vue&type=script&lang=js"
import style0 from "./5GTablet.vue?vue&type=style&index=0&id=4b991e77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b991e77",
  null
  
)

export default component.exports